import { EditGrupoModalForm } from "./EditGrupoModalForm"


const EditGrupoModalFormWrapper = () => {
    return (<EditGrupoModalForm />)
}

export {EditGrupoModalFormWrapper}